import {
  ACCEPT_INVITATION_LOAD_SUCCEEDED,
  ACCEPT_INVITATION_LOAD_FAILED,
  ACCEPT_INVITATION_CONFIRM_SUCCEEDED,
  ACCEPT_INVITATION_CONFIRM_FAILED
} from '../constants/action.types'

const initialState = {
  confirmationError: '',
  loadingError: false,
  loaded: false,
  confirmed: false,
  name: '',
  email: '',
  isUserActive: false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case ACCEPT_INVITATION_LOAD_SUCCEEDED: {
      const { name, email } = action.payload
      return {
        ...state,
        loaded: true,
        name: name,
        email: email
      }
    }
    case ACCEPT_INVITATION_LOAD_FAILED: {
      return {
        ...state,
        loadingError: true
      }
    }
    case ACCEPT_INVITATION_CONFIRM_SUCCEEDED: {
      const { isUserActive } = action.payload
      return {
        ...state,
        isUserActive: isUserActive,
        confirmed: true
      }
    }
    case ACCEPT_INVITATION_CONFIRM_FAILED: {
      const { confirmationError } = action.payload
      return {
        ...state,
        confirmationError: confirmationError
      }
    }
    default:
      return state
  }
}
